<template>
  <div v-if="!$apollo.loading">
    <div class="bg-primary-light pb-8 relative">
      <div class="circle-right hidden lg:block absolute right-0 z-10" aria-hidden="true">
        <img src="~/assets/img/shapes/circle-drk-red.svg">
      </div>
      <SlimHeaderCharacter class="z-20"/>

      <div class="container content-container relative z-30 pt-8">
        <nuxt-link to="/ouders/begeleiders" class="w-auto inline-block btn btn-transparent text-sm mb-3">
          <font-awesome-icon :icon="['fas', 'chevron-left']" size="sm" class="mr-2"/>
          Terug
        </nuxt-link>

        <main class="flex flex-wrap lg:flex-no-wrap justify-center lg:justify-start">
          <aside class="relative z-30 w-auto pt-6 lg:pt-0 lg:flex-shrink lg:mr-4">
            <profile-summary :profile="profiel" :user="profielUser"/>
          </aside>

          <div class="circle-left hidden lg:block absolute z-20" aria-hidden="true">
            <img src="~/assets/img/shapes/circle-light-red.svg">
          </div>

          <section class="order-first lg:order-last w-auto flex-wrap">
            <header class="w-2/3 xl:w-1/3 my-4">
              <h2 class="text-white">{{ profiel.title }}</h2>
              <hr class="mt-1 border-t-2 text-secondary-lighter">
            </header>

            <main class="w-full xl:w-3/4">
              <header class="pt-10 lg:pt-16 pb-6 lg:pb-12 h2 font-light">
                {{ profielUser.introductie }}
              </header>

              <section class="main-content">
                <div class="prose" v-html="profiel.tekst"/>
              </section>
            </main>
          </section>
        </main>
      </div>
    </div>

    <mentor-reviews v-if="referenties.length" :first-name="profielUser.first_name" :reviews="referenties"/>

    <latest-blog-bar v-if="profielUser.blogs.length" :name="profiel.title" :blogs="profielUser.blogs"/>
  </div>
</template>

<script>
import SlimHeaderCharacter from '~/components/headers/SlimHeaderCharacter';
import ProfileSummary from '~/components/begeleiders/ProfileSummary';
import MentorReviews from '~/components/begeleiders/MentorReviews';
import LatestBlogBar from '~/components/blog/LatestBlogBar';
import profiel from '~/graphql/queries/profiel';

export default {
  components: {LatestBlogBar, MentorReviews, ProfileSummary, SlimHeaderCharacter},
  apollo: {
    profiel: {
      query: profiel,
      prefetch: ({route}) => ({slug: route.params.slug}),
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      // When mutating 'referenties', we cannot update this query result because of slug, so don't cache
      fetchPolicy: 'network-only',
    },
  },
  data: () => ({
    profiel: {},
  }),
  computed: {
    profielUser() {
      if (this.$apollo.loading) {
        return false;
      }

      return this.profiel ? this.profiel.users ? this.profiel.users[0] : {} : {};
    },
    referenties() {
      if (this.$apollo.loading) {
        return [];
      }
      return this.profielUser.referenties.filter(referentie => referentie.published);
    },
  },
};
</script>

<style lang="scss" scoped>
.circle-right {
  top: 90px;
}

.circle-left {
  left: -8%;
  top: 25%;
}

.content-container {
  margin-top: -150px; // overlay header
  .main-content {
    column-count: 1;
    @screen lg {
      column-count: 2;
      column-gap: 1rem;
    }
  }
}
</style>
